export default __webpack_public_path__ + "static/media/timingserver.8b791daa.png";